import { tv } from "@fanka/tailwind-variants";
import { clsx } from "clsx";

export const TRIGGER_CLASS_NAME = tv({
  base: clsx(
    // flex
    "flex items-center justify-between gap-3",
    // default
    "w-full max-w-[800px] min-h-fit bg-ui-0 outline-none border rounded-[6px] flex items-center border-ui-200 group",
    // open
    "data-[state=open]:border-grayScale-300",
    // focus
    "focus-within:border-2 focus-within:border-grayScale-400",
  ),
  variants: {
    size: {
      md: "h-[40px] py-2 px-3",
      lg: "h-[50px] py-[13px] px-4",
    },
    error: {
      true: "border-functional-danger hover:bg-functional-danger-light",
      false: "hover:enabled:border-grayScale-300",
    },
    disabled: {
      true: "cursor-not-allowed bg-ui-100 text-base-disabled select-none",
      false: "",
    },
  },
  defaultVariants: {
    size: "md",
    disabled: false,
    error: false,
  },
});

export const ICON_WRAPPER_CLASS_NAME = tv({
  base: clsx(
    "rounded-full",
    // open
    "group-data-[state=open]:bg-ui-300",
    // icon
    "[&_svg]:group-data-[state=open]:fill-ui-white",
  ),
  variants: {
    size: {
      md: "p-1",
      lg: "p-2",
    },
  },
  defaultVariants: {
    size: "md",
  },
});
